<template>
    <div :class="{'pa-3 mt-3': $vuetify.breakpoint.xs, 'mt-5': $vuetify.breakpoint.smAndUp}">
        <v-layout row wrap>
            <v-flex md4 sm6 xs12
                    :class="{'pr-0 mb-4': $vuetify.breakpoint.xsAndDown, 'pr-4': $vuetify.breakpoint.smAndUp}"
            >
                <div class="grey-text mb-2">{{$t("Дата рождения")}}</div>
                <input-base disabled :value="user_page.birth_date" />
            </v-flex>
            <v-flex md4 sm6 xs12
                    :class="{'mt-4 pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.mdAndUp}"
            >
                <div class="grey-text mb-2">{{$t("Номер телефона")}}</div>
                <inputBase disabled :value="user_page.phone_number" />
            </v-flex>
            <v-flex md4 sm12 :class="{'mt-4': $vuetify.breakpoint.smAndDown}">
                <div class="grey-text mb-2">E-mail</div>
                <inputBase disabled :value="user_page.email" />
            </v-flex>
        </v-layout>
        <v-layout row mt-4>
            <v-flex>
                <div class="grey-text mb-2">{{$t("Дополнительная информация")}}</div>
                <textareaBase disabled :value="user_page.additional" rows="4" />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import inputBase from '@/components/ui/inputs/base/input';
import textareaBase from '@/components/ui/inputs/base/textarea';
import linkGreen from '@/components/ui/links/styled/link_green.vue';

export default {
  components: {
    inputBase,
    textareaBase,
    linkGreen,
  },
  props: {
    user_page: {
      type: Object,
    },
  },
  data() {
    return {
      aboutOverflow: false,
      aboutOpened  : false,
    };
  },
};
</script>

<style lang="less" scoped>
.readmore {
  min-height: 180px;
  font-size: 18px;
  line-height: 1.78;
  padding: 14px 20px;
  background-color: #f9f9f9;
  border-color: #f9f9f9;
}
.readmore-text {
  // max-height: 100%;
  // overflow: hidden;
  height: 80%;
}
.readmore .hide {
  height: 180px;
  overflow: hidden;
}
</style>
